import { useMemo } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { useIsSpaceOrSiteAdmin } from './useIsSpaceOrSiteAdmin.ts';

export const useIsAllowedToChangeOwner = (ownedByAccountId: string | null): boolean => {
	const { userId } = useSessionData();
	const isSpaceOrSiteAdmin = useIsSpaceOrSiteAdmin();

	return useMemo(() => {
		if (!userId) {
			return false;
		}
		const isCurrentUserOwner = ownedByAccountId === userId;
		return isSpaceOrSiteAdmin || isCurrentUserOwner;
	}, [isSpaceOrSiteAdmin, ownedByAccountId, userId]);
};
